import server from '../request';
import encryptServer from '../request/encryptRequest';

// 分页查询操作日志
export const queryLogListById = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/seller/queryLogListById', data);
};

// 提货订单列表(分页)
export const queryPage = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/pageList', data);
};

// 导出提货订单
export const exportOrderDelivery = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/exportOrderDelivery', data, { responseType: 'blob' });
};

// // 提货订单详情
// export const queryDetail = (data = {}) => {
//   return encryptServer.post('/xiaozi-xms/wireless/saas/order/details', data);
// };

// 提货订单列表(分页)
export const orderLogs = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/log/pageList', data);
};

// 提货订单详情(新)
export const queryOrderDetail = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/detail', data);
};

// 订单数量统计
export const querySaleOrderCount = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/count', data);
};

// 物流公司列表
export const customerPage = (data = {}) => {
  return server.post('/xiaozi-xms/wireless/saas/customer/page', data);
};

// 物流公司列表
export const getSupplierPage = (data = {}) => {
  return encryptServer.post('/xiaozi-xmo/wireless/saas/xz/erp/supplier/pageList', data);
};

// 物流公司列表(新)
export const logisticsCompany = (data = {}) => {
  return encryptServer.post('/xiaozi-xmo/wireless/saas/logisticsCompany/pageList', data);
};

// 发货详情
export const sellerDeliveAdd = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/notice/sellerDeliveAdd', data);
};

// 订单发货
// 直发订单按件提交序列明细，大额订单请求体较大，加密与上传耗时均会超过默认的 8s 超时，改为2分钟
export const deliver = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/notice/deliver', data, { timeout: 1000 * 60 * 2 });
};

// 增量拉取小紫ERP订单
export const pullXzErpOrder = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/pullXzErpOrder', data, { timeout: 1000 * 60 * 5 });
};

// 新增发货单
export const addDelivery = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/add', data, { timeout: 1000 * 60 * 2 });
};

// 批量新增发货单
export const batchAdd = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/batchAdd', data, { timeout: 1000 * 60 * 2 });
};

// 确认订单
export const confirm = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/confirm', data);
};

// 驳回订单
export const reject = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/reject', data);
};

// 为创建发货单查询订单详情
export const getOrderDetailForDelivery = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/order/getOrderDetailForDelivery', data);
};
